import React from "react";
import ReactDOM from "react-dom";

export interface IRemoChildrenProps {
  closeModal: () => void;
}

export interface IRemoProps {
  show: boolean;
}

class Remo extends React.Component<IRemoProps> {
  private defaultStyles = {
    remomodal: {
      backgroundColor: "rgba(0,0,0,0.5)",
      font: "Helvetica Neue",
      height: "100vh",
      left: "0px",
      margin: "0 auto",
      position: "absolute",
      top: "0px",
      width: "100%"
    }
  };

  private el = document.createElement("div");

  constructor(props) {
    super(props);
    this.el.className = "RemoOverlay";
    this.el;

    this.state = {
      showModal: false
    };
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  public render() {
    return this.props.show
      ? ReactDOM.createPortal(
          <div style={this.defaultStyles.remomodal as any}>
            {this.props.children}
          </div>,
          this.el
        )
      : null;
  }
}

export default Remo;
